import Blue from "~/core";

new Blue({
	name: 'Modal Popup',
	selector: ".form-modal__trigger",
	setup(trigger) {
		const page = document.querySelector(".page");
		const modal = document.querySelector(".form-modal");
		const overlay = modal.querySelector(".form-modal__overlay");
		const closeBtn = modal.querySelector("button.form-modal__close");
		const submit = modal.querySelector("input[type=submit") || modal.querySelector("button[type=submit") || false;

		const showModal = () => {
			modal.classList.add("visible");
			page.style.overflow = "hidden";
			document.body.style.overflow = "hidden";
			closeBtn.focus();
		}

		const closeModal = () => {
			modal.classList.remove("visible");
			page.style.overflow = "";
			document.body.style.overflow = "";
			trigger.focus();
		}

		this.$addEvents(trigger, "click", (e) => {
			e.preventDefault();
			showModal();
		});
		this.$addEvents(closeBtn, "click", () => {
			closeModal();
		});
		this.$addEvents(overlay, "click", (e) => {
			if (!e.target.closest(".form-modal__content")) {
				closeModal();
			}
		});

		if (submit) {
			this.$addEvents(submit, "tab", (e) => {
				e.preventDefault();
				closeBtn.focus();
			});
			this.$addEvents(closeBtn, "tab.shift", (e) => {
				e.preventDefault();
				submit.focus();
			});
		}
		
	}
});